import makeStyles from '@material-ui/core/styles/makeStyles';
import { darken } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
          height: '80%',
        },
    },
    container: {
        width: ({ isTablet }) => isTablet ? '100%' : 380,
        height: '100vh',
        color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
        backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
        [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
            height: '100%',
        },
    },
    searchIcon: {
        width: 22,
        height: 22,
        marginLeft: 12,
        cursor: 'pointer',
        opacity: 1,
        transition: '0.15s',
        color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropMutedColor,
    },
    closeIcon: {
        width: 18,
        height: 18,
        marginRight: 5,
        cursor: 'pointer',
        transition: '0.35s',
        color: theme.palette.colors.surfaceOnColor,
    },
    searchInputContainer: {
        width: '100%',
        padding: 10,
        display: 'flex',
    },
    searchInput: {
        flexGrow: 1,
        height: 36,
        transition: '0.35s',
        color: theme.palette.colors.surfaceOnColor,
        boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.05)',
        borderRadius: 6,
        border: `1px solid ${theme.palette.colors.readerPrimaryColor}`,
        backgroundColor: theme.palette.colors.surfaceColor,
        '& input::placeholder': {
            color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropMutedColor,
            opacity: 1,
        },
    },
    searchInputMuted: {
        border: ({ activeTheme }) => `1px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
    },
    searchButton: {
        height: 36,
        marginLeft: 5,
        color: theme.palette.colors.readerPrimaryColor,
        border: `1px solid ${theme.palette.colors.readerPrimaryColor}`,
        '&:disabled, &[disabled]': {
            color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropMutedColor,
            border: ({ activeTheme }) => `1px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
        }
    },
    resultListContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'scroll',
        backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
    },
    resultListContent: {
        width: '100%',
        height: '100%',
        padding: 15,
    },
    result: {
        margin: '10px 0',
        padding: '10px 0',
        borderBottom: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor} !important`,
        cursor: "pointer",
        "&:hover": {
            backgroundColor: ({ activeTheme }) => darken(theme.reader.colors[activeTheme]?.backdropColor, 0.1),
        },
    },
    textMatch: {
        color: theme.palette.colors.readerPrimaryColor,
    },
    contextText: {
        fontStyle: "italic",
    },
    resultInfo: {
        paddingTop: 10,
        display: 'flex',
    },
    resultChapter: {
        fontWeight: 'bold',
        marginRight: 'auto',
    },
    messageContainer: {
        marginTop: 50,
        textAlign: 'center',
    },
    messageTitle: {
        fontWeight: 'bold',
        padding: 5,
        marginBottom: 10,
    },
    tabIndicator: {
        backgroundColor: theme.palette.colors.readerPrimaryColor,
    },
    tab: {
        borderBottom: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor} !important`,
        textTransform: "none",
    },
    tabMuted: {
        color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropMutedColor,
    },
}));

export default useStyles;
